<!--登录-->
<template>
    <div class="loginPage">
        <div class="cenBackground">
            <div class="center">
                <div class="topTit">
                    <p class="hello">Hello!</p>
                    <p>欢迎您登录网关调度平台</p>
                </div>
                <el-form
                    :model="ruleForm"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    :rules="rules"
                >
                    <el-form-item label="账号" prop="user_name"
                        ><br />
                        <el-input
                            placeholder="请输入账号"
                            style="margin-left: -42px"
                            v-model="ruleForm.user_name"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="密码"
                        prop="pwd"
                        style="position: relative"
                        ><br />
                        <el-input
                            placeholder="请输入登录密码"
                            style="margin-left: -42px"
                            v-model="ruleForm.pwd"
                            @keyup.enter.native="loadData('ruleForm')"
                            show-password
                        ></el-input>
                    </el-form-item>
                </el-form>
                <div class="loginBox">
                    <el-button
                        class="loginBtn"
                        type="primary"
                        @click="loadData('ruleForm')"
                        :loading="loginLoading"
                        size="mini"
                        >登录</el-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { logins } from "@/api/login";
export default {
    name: "Login",
    components: {},
    data() {
        return {
            ruleForm: {
                user_name: "",
                pwd: "",
            },
            rem: false, // 记住密码
            passwordImg: [
                require("../../static/img/RemPicture.png"),
                require("../../static/img/unChecked.png"),
            ],
            rules: {
                user_name: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: "change",
                    },
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "change",
                    },
                ],
            },
            loginLoading: false,
        };
    },
    computed: {},
    watch: {},
    methods: {
        // RSA加密
        setPublicKeys(pwd) {
            let encrypt = new this.$jsEncrypt();
            const PUBLIC_KEY =
                "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDuTgFLuRgRPEkTLr3TYNXrTWx+cRM2VCh6fxQHcNjoeGoPMbKT2BlY3bb7/Yk5UolEWNEVEx8q2y/Vmr3pQeugVmdVEr5FyqpHvF420M00sRzc0LVzyrITGWzO877GY2hKhxOtWrmE2ITOJp7/6MHWYfdCjGpfRA9FyPCJU8PxeQIDAQAB";
            encrypt.setPublicKey(
                "-----BEGIN PUBLIC KEY-----" +
                    PUBLIC_KEY +
                    "-----END PUBLIC KEY-----"
            );
            // 加密内容
            let encrypted = encrypt.encrypt(pwd);
            return encrypted;
        },
        // RSA解密
        setPrivateKeys(pwd) {
            var decrypt = new this.$jsEncrypt();
            const PRIVATE_KEY =
                "MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAO5OAUu5GBE8SRMuvdNg1etNbH5xEzZUKHp/FAdw2Oh4ag8xspPYGVjdtvv9iTlSiURY0RUTHyrbL9WavelB66BWZ1USvkXKqke8XjbQzTSxHNzQtXPKshMZbM7zvsZjaEqHE61auYTYhM4mnv/owdZh90KMal9ED0XI8IlTw/F5AgMBAAECgYAKZzNdR+ZKElSqVrcIvEh6bjXXSz5od8IQnu2T6ZQ+icsvgJ7oH13z6DHtzEKqUvUVG7986QnKSClNbOTvguYzUx8Sk0T1RbxSs4PvZJjoyHG4H3QizrACtmX2kvUk85RMQcHW7YcG96hh4XzYNdSlZw4pUdOVcjg7mV1DGOKVAQJBAP6WH3p0fofeNcMOx3DXpykCv6tYmyngCbiiNOJaBNn1hgmDO1i7QDow7avScxFqHNm5WfAT41AJ1L1qEQ3zgGECQQDvoL0gEeUVvF9MYSj/HZsC6XnUuACNPaTyInkOpRmFCqDfciPcDt3srhz6sHsQWpE0K58PU8aByPhIvdDu9WgZAkBR7zbKTlu6loVu9X6yjnU5+ax+FNI7M+NtDKdAggA1tZMh1J5w/DK7h6u2NNDbte77E3AimAP8am2RWGWMu+WBAkEAubJDva2AbOasp0EIByOHM6uA2SK6crnZsDacv4ecDiidYGtQdMEko7yOAotu4s58hgRj3/nY9Eysc5p9ZiDRSQJAWbtPN9bzqfR5ukVmx50rFk2TDFGFNfBt2VfM8PDSEcAXc+gAI07T2FsvzQfA3lHGENu3Wj3Ne/t3Y5ePDyKa/w==";
            decrypt.setPrivateKey(
                "-----BEGIN RSA PRIVATE KEY-----" +
                    PRIVATE_KEY +
                    "-----END RSA PRIVATE KEY-----"
            );
            let uncrypted = decrypt.decrypt(pwd);
            return uncrypted;
        },
        // 登录
        loadData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loginLoading = true;
                    let { pwd, user_name } = this.ruleForm;
                    // if (user_name == "admin" && pwd == "admin") {
                    //     this.$router.push("/nav");
                    // } else if (user_name == "user1" && pwd == "123456") {
                    //     this.$router.push("/home");
                    // } else if (user_name == "user2" && pwd == "123456") {
                    //     this.$router.push("/home2");
                    // }
                    // this.loginLoading = false;

                    let params = { user_name, pwd: this.setPublicKeys(pwd) };
                    if (this.rem) {
                        this.$cookie.set(
                            "userInfor",
                            JSON.stringify(params),
                            60 * 60 * 24 * 7
                        );
                    } else {
                        this.$cookie.remove("userInfor");
                    }
                    logins(params)
                        .then((res) => {
                            this.loginLoading = false;
                            if (res.errorNo != 0) {
                                this.$message.error(
                                    res.errorInfo || "密码或账户错误"
                                );
                                return false;
                            }
                            this.$message.success("登录成功!");
                            this.$cookie.set(
                                "userName",
                                params.user_name,
                                60 * 60 * 24 * 7
                            );
                            this.$cookie.set(
                                "token",
                                res.data.token,
                                60 * 60 * 24 * 7
                            );
                            this.$cookie.set(
                                "userType",
                                res.data.userType,
                                60 * 60 * 24 * 7
                            );
                            // this.$cookies.set("menuNum", 0);
                            if (res.data.userType == "1") {
                                this.$router.push("/nav");
                            } else if (res.data.userType == "2") {
                                this.$router.push("/home");
                            } else {
                                this.$router.push("/homeDd");
                            }
                        })
                        .catch(() => {
                            this.loginLoading = false;
                        });
                } else {
                    this.$message.error("请输入用户名和密码!");
                    return false;
                }
            });
        },
    },
    created() {
        let userInfor = this.$cookies.get("userInfor");
        if (userInfor) {
            userInfor.pwd = this.setPrivateKeys(userInfor.pwd);
            this.ruleForm = userInfor;
            this.rem = true;
        }
    },
    mounted() {},
};
</script>
<style lang="less" scoped>
.loginPage {
    width: 100%;
    height: 100%;
    background: #eceff5;
    background: url("../../static/img/loginBG.jpg") center center no-repeat;
    background-size: 100% auto;
    position: relative;
    .cenBackground {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 31%;
        right: 12%;
        .center {
            width: 500px;
            height: 350px;
            background-image: url(../../static/img/loginBack.png);
            background-size: contain;

            .topTit {
                width: 100%;
                padding: 50px 50px 20px 50px;

                .hello {
                    font-size: 20px;
                    font-weight: bold;
                }
            }

            .forgetPwd {
                width: 100%;
                height: 30px;
                display: flex;
                justify-content: space-between;
                padding: 0 50px;

                .pawImage {
                    width: 15px;
                    height: 15px;
                    margin-right: 5px;
                    margin-bottom: 3px;
                    vertical-align: middle;
                }

                .rePaw {
                    cursor: pointer;
                    font-size: 14px;
                    margin-left: 5px 2px;
                }

                .foPaw {
                    font: 13px;
                    color: gray;
                }
            }

            .loginBtn {
                background-color: rgb(19, 169, 201);
                // width: 55px;
                // height: 22px;
                border: 0;
                color: white;
                border-radius: 4px;
                font-size: 13px;
                // margin: -40px;
                outline: none;
            }

            .showPwd {
                position: absolute;
                bottom: 13px;
                right: 50px;
            }
        }
    }
    ::v-deep .el-input__inner {
        background-color: #fff !important;
        border: 1px solid #fff !important;
        color: #333 !important;
    }
    ::v-deep .el-form-item__label {
        color: #333 !important;
    }
}

.loginBox {
    width: 100%;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

/deep/.el-form-item__error {
    left: -37px;
}
</style>
